// pages/Profile.js
import ProfileForm from "../../components/pages/profile/ProfileForm";

export default function ProfilePage() {
  return <ProfileForm />;
}
